module.exports = __webpack_public_path__ + "static/img/meiti22.9351a5a7.png";